function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { getReactRoot } from 'oskari-ui/components/window';
import { Message } from 'oskari-ui';
import { Messaging, LocaleProvider } from 'oskari-ui/util';
import { MainPanel } from './components/MainPanel';
import { showPopup, hidePopup } from './components/Popup';
import { Basket } from './basket';
import { processFeatures } from './helpers/featureshelper';
import { getLayers, getLayerFromService } from './helpers/layerHelper';
import { getFeaturesInGeom } from './helpers/geomSelector';
import { createFeatureClickHelper } from '../util/FeatureClickHelper';
import { QNAME as SELECTION_SERVICE_NAME } from 'oskari-frontend/bundles/mapping/mapmodule/service/VectorFeatureSelectionService';
Basket.onChange(updateUI);
var BasicBundle = Oskari.clazz.get('Oskari.BasicBundle');
var FEATURE_SELECT_ID = 'attachmentSelection';
var isDrawing = false;
var startDrawSelection = function startDrawSelection() {
  Oskari.getSandbox().postRequestByName('DrawTools.StartDrawingRequest', [FEATURE_SELECT_ID, 'Polygon']);
  isDrawing = true;
  updateUI();
};
var endDrawSelection = function endDrawSelection() {
  Oskari.getSandbox().postRequestByName('DrawTools.StopDrawingRequest', [FEATURE_SELECT_ID, true, true]);
  isDrawing = false;
  updateUI();
};
var toggleDrawing = function toggleDrawing() {
  isDrawing ? endDrawSelection() : startDrawSelection();
};
var BUNDLE_ID = 'file-layerlist';
var FileLayerListBundle = /*#__PURE__*/function (_BasicBundle) {
  function FileLayerListBundle() {
    var _this;
    _classCallCheck(this, FileLayerListBundle);
    _this = _callSuper(this, FileLayerListBundle);
    _this.__name = BUNDLE_ID;
    _this.loc = Oskari.getMsg.bind(null, _this.__name);
    _this.clickHelper = createFeatureClickHelper();
    _this.clickHelper.addListener(function (coords, features) {
      processFeatures(features, function (processedFeatures) {
        showPopup(coords.lon, coords.lat, processedFeatures[0]);
      });
    });
    _this.eventHandlers = {
      AfterMapLayerAddEvent: function AfterMapLayerAddEvent() {
        _this.clickHelper.setLayer(getSelectedWFSLayerId());
        updateUI();
      },
      AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent() {
        _this.clickHelper.setLayer(getSelectedWFSLayerId());
        updateUI();
      },
      DrawingEvent: function DrawingEvent(event) {
        if (!event.getIsFinished() || event.getId() !== FEATURE_SELECT_ID) {
          // only interested in finished drawings for attachment selection
          return;
        }
        endDrawSelection();
        var layerId = getSelectedWFSLayerId();
        if (!layerId) {
          return;
        }
        var features = getFeaturesInGeom(event.getGeoJson().features[0].geometry, layerId);
        var mapped = features.map(function (f) {
          var value = _objectSpread(_objectSpread({}, f.getProperties()), {}, {
            _$layerId: layerId
          });
          delete value.geometry;
          return value;
        });
        processFeatures(mapped, function (features) {
          var featuresWithFiles = features.filter(function (feat) {
            return feat._$files && feat._$files.length;
          });
          featuresWithFiles.forEach(function (feat) {
            Basket.add(feat);
          });
          if (featuresWithFiles.length) {
            Messaging.success(/*#__PURE__*/React.createElement(Message, {
              messageKey: "addedToBasket",
              bundleKey: BUNDLE_ID
            }));
          } else {
            Messaging.warn(/*#__PURE__*/React.createElement(Message, {
              messageKey: "drawNoHits",
              bundleKey: BUNDLE_ID
            }));
          }
        });
      }
    };
    return _this;
  }
  _inherits(FileLayerListBundle, _BasicBundle);
  return _createClass(FileLayerListBundle, [{
    key: "_startImpl",
    value: function _startImpl() {
      updateUI();
    }
  }]);
}(BasicBundle);
function getSelectedWFSLayerId() {
  var selectedLayers = Oskari.getSandbox().getMap().getLayers().filter(function (l) {
    return l.isLayerOfType('WFS');
  });
  if (!selectedLayers.length) {
    // No WFS-layers selected
    // TODO: don't allow draw if no layers selected...
    return;
  }
  return selectedLayers[0].getId();
}
function highlightFeatures() {
  var selectionService = Oskari.getSandbox().getService(SELECTION_SERVICE_NAME);
  selectionService.removeSelection();
  var features = Basket.list();
  if (!features.length) {
    return;
  }
  var layer = getLayerFromService(getSelectedWFSLayerId());
  if (!layer) {
    return;
  }
  var featureIds = features.filter(function (f) {
    return f._$layerId === layer.getId();
  }).map(function (f) {
    return f._oid;
  });
  selectionService.setSelectedFeatureIds(layer.getId(), featureIds);
  // TODO: group by layer etc
}
function updateUI() {
  getLayers(function (layers) {
    // hide any possibly open popups on map before re-render (in case layer was removed etc)
    hidePopup();
    // update highlighted features based on basket content
    highlightFeatures();
    var selectedLayers = Oskari.getSandbox().getMap().getLayers();
    getReactRoot(getRoot()).render(/*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: BUNDLE_ID
      }
    }, /*#__PURE__*/React.createElement(MainPanel, {
      layers: layers,
      selectedLayers: selectedLayers,
      drawControl: toggleDrawing,
      isDrawing: isDrawing
    })));
  });
}
var root = null;
function getRoot() {
  if (!root) {
    var mapEl = document.getElementById('contentMap');
    root = document.createElement('div');
    mapEl.appendChild(root);
  }
  return root;
}

// so bundle.js can reference this
Oskari.clazz.defineES('Oskari.file-layerlist.BundleInstance', FileLayerListBundle);